import React from 'react';
import Footer from '../Footer/Footer';
import MenuBar from '../MenuBar/MenuBar';
import './NotFound.css';

const NotFound = () => {
    return (
        <div>
        <div className='container'>
            <MenuBar></MenuBar>
            <div className="container-fluid">
                <img className="img-fluid img-class" src="https://colorlib.com/wp/wp-content/uploads/sites/2/404-error-template-3.png" alt="" />
            </div>
            
        </div>
            <Footer></Footer>
        </div>
    );
};

export default NotFound;